import request from '@/utils/request'

export function updateRedCircleCfg(data) {
  return request({
    url: 'api/v1/red-circle/updateCfg',
    method: 'post',
    data: data
  })
}

export function getRedCircleStatus(data) {
  return request({
    url: 'api/v1/red-circle/getStatus',
    method: 'post',
    data: data
  })
}

export function getRedCircleCfgList(data) {
  return request({
    url: 'api/v1/red-circle/getList',
    method: 'post',
    data: data
  })
}

export function delRedCircleCfgList(data) {
  return request({
    url: 'api/v1/red-circle/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function exportRedCircleCfg() {
  return request({
    url: 'api/v1/red-circle/export',
    method: 'post'
  })
}

export function importRedCircleCfg(data) {
  return request({
    url: 'api/v1/red-circle/import',
    method: 'post',
    data: data
  })
}

